export { default as ROOM_LIST } from '../mocks/rooms.json';
